import React from "react";
import backgroundCheckLogo from "../../assets/img/background_check_logo.png";
import backgroundCheckIcon from "../../assets/img/background_check_icon.png";
import dataworkerLogo from "../../assets/img/dataworker_logo.png";

interface LogoComponentProps {
	height?: number;
	className?: string;
	variant?: "full" | "icon";
}

const LogoComponent = ({ height = 90, className, variant = "full" }: LogoComponentProps) => {

	return (window.location.href.includes("backgroundcheck")) ? (
		<img
			src={variant === "icon" ? backgroundCheckIcon : backgroundCheckLogo}
			alt="Background Check RD"
			height={height}
			className={className}
		/>
	) : (
		<img src={dataworkerLogo} alt="Data Worker" height={height} className={className} />
	)
}

export default LogoComponent;